<template>

  <inventory-calendar-popup :title="title">

    <template v-slot:tools>

      <v-btn-group>
        <v-btn icon="$edit" :title="$t('actions.update_inventory')" @click="$emit('edit')" />
        <v-btn icon="$inventoryBreakdown" :title="$t('actions.view_breakdown')" @click="$emit('viewBreakdown')" />
      </v-btn-group>

    </template>

    <p class="text-center">{{ item.spacesSold }}/{{ item.spacesTotal }}</p>

  </inventory-calendar-popup>

</template>

<script setup lang="ts">

import { computed } from 'vue'

// components
import InventoryCalendarPopup from './InventoryCalendarPopup.vue'
import type { MonthNormalInventoryCalendarItem } from '../calendarItemTypes'

// models
interface Props {
  item: MonthNormalInventoryCalendarItem
}

const props = defineProps<Props>()

// const $emit = defineEmits(['edit', 'addException'])

const title = computed<string>(() => {
  return props.item.locationProduct.product.name
})

</script>
